import { createContext, useContext, useEffect, useState } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth, authSecondary } from '../firebase';

export const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const navigate = useNavigate();

  const createUser = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

   const signIn = async (email, password) =>  {
    const primaryP = signInWithEmailAndPassword(auth, email, password);
    try {
      await signInWithEmailAndPassword(authSecondary, email, password);
    } catch (e) {
      console.warn("Could not sign in to secondary auth", e.message);
    }
    return primaryP;
   }

  const logout = async () => {
    try {
      await signOut(authSecondary).catch(e => console.warn(e));
      await signOut(auth);
      setUser(null);          // limpia el estado de React (necesario en modo mockAuth, inofensivo con auth real)
      navigate('/login');
    } catch (e) {
      console.log(e.message);
    }
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    // Backdoor de desarrollo: solo disponible fuera de producción.
    const mockAuth = process.env.NODE_ENV !== "production" && searchParams.get("mockAuth");
    if (mockAuth) {
      const mockUid = searchParams.get("mockUid") || "YXNFY5c1O2Qnf4pVhmLz5pNs9952";
      setUser({
        uid: mockUid,
        email: "cristian@tnk.la"
      });
      return;
    }
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{ createUser, user, logout, signIn }}>
      {children}
    </UserContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(UserContext);
};
